import styles from './index.module.css'

import { RightsData } from '@disco/types/types/rights-data'
import { Flex, Heading, Table, Text } from '@radix-ui/themes'
import React from 'react'

const renderNonZero = (value, prefix = '', suffix = '') => {
  if (value != 0) {
    return `${prefix}${value}${suffix}`
  }

  return ''
}

export function RightsDataTable(props: {
  rightsData: RightsData
}): React.ReactNode {
  const publishers = props.rightsData.publishers
  const writers = {}
  props.rightsData.publishers.forEach(publisher => {
    publisher.represented_writers.forEach(writer => {
      const key =
        writer.ipi && writer.ipi !== '0' && writer.ipi !== ''
          ? writer.ipi
          : `unknown-${writer.name}`
      writers[key] = 1
    })
  })
  const split_total = props.rightsData.publishers.reduce((acc, publisher) => {
    return acc + publisher.splits.reduce((acc2, split) => acc2 + split.split, 0)
  }, 0)
  const publishingColumns = [
    'Publisher',
    `Writers${renderNonZero(Object.keys(writers).length, ' • ')}`,
    `Split${renderNonZero(split_total, ' • ', '%')}`,
    'Admin',
  ].map(column => {
    return (
      <Table.ColumnHeaderCell key={column}>{column}</Table.ColumnHeaderCell>
    )
  })

  const publishingRows = publishers.map((publisher, ind) => {
    return (
      <Table.Row key={ind}>
        <Table.RowHeaderCell>
          <Flex direction="column">
            <Text size="1">{publisher.publisher.name}</Text>
            <Text size="1">
              {renderNonZero(publisher.publisher.ipi, '(IPI: ', ')')}
            </Text>
          </Flex>
        </Table.RowHeaderCell>
        <Table.Cell>
          {publisher.represented_writers.map(writer => (
            <Flex direction="column" key={writer.ipi}>
              <Text size="1">{writer.name}</Text>
              <Text size="1">{renderNonZero(writer.ipi, '(IPI: ', ')')}</Text>
            </Flex>
          ))}
        </Table.Cell>
        <Table.Cell>
          {publisher.splits.map((split, ind) => (
            <Text size="1" key={ind}>
              {split.split}%
            </Text>
          ))}
        </Table.Cell>
        {publisher.admin && (
          <Table.Cell>
            <Flex direction="column">
              <Text size="1">{publisher.admin.name}</Text>
              {publisher.admin.parent && (
                <Text size="1">{publisher.admin.parent}</Text>
              )}
              <Text size="1">
                {renderNonZero(publisher.admin.ipi, '(IPI: ', ')')}
              </Text>
            </Flex>
          </Table.Cell>
        )}
      </Table.Row>
    )
  })

  return (
    <>
      <Heading size="2">
        <span>
          Publishing{' '}
          <span>
            {props.rightsData.iswc ? ` - ISWC: ${props.rightsData.iswc}` : ''}
          </span>
        </span>
      </Heading>
      <Table.Root size="1" variant="surface" className={styles.publishingTable}>
        <Table.Header>
          <Table.Row>{publishingColumns}</Table.Row>
        </Table.Header>
        <Table.Body>
          {publishingRows}
          <Table.Header className={styles.headerChanges}>
            <Table.Row>
              <Table.ColumnHeaderCell colSpan={4}>
                All Writers
              </Table.ColumnHeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Row>
            <Table.Cell colSpan={4}>
              <Text size="1">
                All writers: {props.rightsData.all_writers.join(', ')}
              </Text>
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table.Root>
      <Heading size="2">Recording</Heading>
      <Table.Root variant="surface" size="1">
        <Table.Header>
          <Table.ColumnHeaderCell>Label</Table.ColumnHeaderCell>
          <Table.ColumnHeaderCell>ISRC</Table.ColumnHeaderCell>
        </Table.Header>
        <Table.Body>
          <Table.Row>
            <Table.RowHeaderCell>
              <Text size="1">{props.rightsData.master.label}</Text>
            </Table.RowHeaderCell>
            <Table.Cell>
              <Text size="1">{props.rightsData.master.isrc}</Text>
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table.Root>
    </>
  )
}
